import { createStyles, rem } from "@mantine/core"

interface UseStylesProps {
    isSelected: boolean
}

export const useStyles = createStyles((theme, { isSelected }: UseStylesProps) => ({
    orderChild: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",

        borderRadius: rem(32),
        border: `1px solid ${theme.colors.gray[4]}`,
        padding: "4px 16px 4px 4px",

        maxWidth: isSelected ? "100%" : rem(155),
        minWidth: rem(155),
        overflow: "hidden",

        transition: "max-width 0.5s ease",
    },

    icon: {
        minWidth: rem(36),
        width: rem(36),
        height: rem(36),

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        borderRadius: "50%",
        backgroundColor: isSelected ? theme.colors.green[1] : theme.colors.gray[1],
        color: isSelected ? theme.colors.green[7] : theme.colors.gray[7],

        marginRight: theme.spacing.sm,
    },

    infoContainer: {
        color: theme.colors.gray[7],
    },

    position: {
        fontSize: theme.fontSizes.xs,
        marginBottom: 0,
    },

    campaignType: {
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,
        marginBottom: 0,
        whiteSpace: "nowrap",
    },
}))
